import type { IconName } from "@blueprintjs/core";
import { Icon, Switch } from "@blueprintjs/core";
import type { ColDef, ICellRendererParams } from "ag-grid-community";

export type ItemGridSortOrder = "ASC" | "DESC";

export function createColDef<T>(
  field: keyof T,
  headerName: string,
  flex = 1,
  minWidth = 100,
): ColDef {
  return {
    colId: field.toString(),
    field: field.toString(),
    headerName,
    sortable: true,
    resizable: true,
    flex,
    minWidth,
  };
}

export function createColDefCheckmark<T>(
  field: keyof T,
  headerName: string,
  icon: IconName = "tick",
): ColDef {
  return {
    ...createColDef<T>(field, headerName, 0, 100),
    flex: undefined,
    resizable: false,
    maxWidth: 100,
    cellRenderer: (params: ICellRendererParams<T, boolean>) => (
      <Icon icon={params.value ? icon : "blank"} />
    ),
  };
}

export function createColDefToggleSwitch<T>(
  field: keyof T,
  headerName: string,
  updateInflight: boolean,
  onToggle: (node: T, value: boolean) => void,
  disabled = false,
): ColDef {
  return {
    ...createColDef<T>(field, headerName, 0, 100),
    flex: undefined,
    resizable: false,
    maxWidth: 100,
    cellRenderer: (params: ICellRendererParams<T, boolean>) =>
      params.data && (
        <Switch
          checked={!!params.value}
          disabled={updateInflight || disabled}
          onChange={() => params.data && onToggle(params.data, !params.value)}
        />
      ),
  };
}
